







































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import QuoteFormRecordType from '@/modules/Quote/components/forms/QuoteFormRecordType.vue'
import QuoteFormCarrierProduct from '@/modules/Quote/components/forms/QuoteFormCarrierProduct.vue'
import QuoteFormAccount from '@/modules/Quote/components/forms/QuoteFormAccount.vue'
import QuoteFormInfo from '@/modules/Quote/components/forms/QuoteFormInfo.vue'
import QuoteFormSource from '@/modules/Quote/components/forms/QuoteFormSource.vue'
import QuoteFormAdditional from '@/modules/Quote/components/forms/QuoteFormAdditional.vue'
import { Quote } from '@/modules/Quote/interfaces/quote'
import RecordTypesHandler from '@/mixins/record-types'
import { newQuote, editQuote } from '@/modules/Quote/gql/quote.gql'
import { Case } from '@/modules/Case/interfaces/case'
import { Account } from '@/modules/Account/interfaces/account'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { IQuoteRecordTypeInput, IQuoteCarrierProductInput, IQuoteAccountInput, IQuoteInfoInput, IQuoteSourceInput, IQuoteAdditionalInfoInput } from '@/modules/Quote/interfaces/quote-form'
import { quoteStatusKeys, quoteTypeValues, quoteTypeKeys } from '@/modules/Quote/helpers/quote'
import { states } from '@/utils/us_states'

@Component({
  components: {
    QuoteFormRecordType,
    QuoteFormCarrierProduct,
    QuoteFormAccount,
    QuoteFormInfo,
    AppDialog,
    QuoteFormSource,
    QuoteFormAdditional,
    AppSteps
  }
})
export default class QuoteForm extends mixins(RecordTypesHandler) {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
  @Prop({ type: Object as () => Account }) readonly accountInfo!: Account
  @Prop({ type: Object as () => Contact }) readonly contactInfo!: Contact
  @Prop({ type: Object as () => CarrierProduct }) readonly carrierProductInfo!: CarrierProduct
  @Prop({ type: Object as () => Producer }) readonly producerInfo!: Producer

  showDialog = false
  loading = false

  stepIndex = 0
  steps = [
    ['Record Type', 680, 561],
    ['Insurance Product', 770, 301],
    ['Account Info', 770, 301],
    ['Quote Info', 770, 431],
    ['Source Info', 770, 301],
    ['Additional Info', 770, 561]
  ]

  recordTypeInput: IQuoteRecordTypeInput = {
    recordType: {}
  }

  carrierProductInput: IQuoteCarrierProductInput = {
    carrierProduct: {}
  }

  accountInput: IQuoteAccountInput = {
    account: {},
    primaryContact: {}
  }

  infoInput: IQuoteInfoInput = {
    name: '',
    typeIdx: -1,
    statusIdx: -1,
    priorTerm: {},
    originalInceptionDate: ''
  }

  sourceInput: IQuoteSourceInput = {
    source: {}
  }

  additionalInfoInput: IQuoteAdditionalInfoInput = {}

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get hightLightTitle () {
    return this.recordTypeInput.recordType.name ? ' (' + this.recordTypeInput.recordType.name + ')' : ''
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.quote
        ? 'Save'
        : 'Create'
  }

  get confirmAheadText () {
    return this.quote ? 'Save' : 'Create'
  }

  get canPost () {
    return this.stepIndex > 2 && this.stepIndex < 5
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    this.showDialog = val
    if (val) {
      this.resetStep()
      this.initInput()
    }
  }

  @Watch('stepIndex')
  onStepChanged (val: number) {
    const {
      recordTypeInput: {
        recordType
      },
      accountInput: {
        account
      },
      infoInput: {
        typeIdx,
        name
      }
    } = this

    if (val !== 3 || !account.name || name) {
      return
    }

    const quoteType = quoteTypeValues[typeIdx] ? quoteTypeValues[typeIdx] + '-' : ''
    const year = this.$moment.tz('America/New_York').year()

    this.infoInput.name = `${account.name}-${recordType.name}-Quote-${quoteType}${year}`
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.quote) {
      const {
        recordType, account, primaryContact, carrierProduct, source,
        name, type, status, priorTerm, originalInceptionDate, additionalInfoStr
      } = this.quote
      this.recordTypeInput = {
        recordType: {
          id: +recordType.id,
          name: recordType.name
        }
      }
      this.carrierProductInput = {
        carrierProduct: {
          id: carrierProduct ? +carrierProduct.id : undefined,
          name: carrierProduct ? carrierProduct.name : ''
        }
      }
      this.accountInput = {
        account: {
          id: +account.id,
          name: account.name
        },
        primaryContact: {
          id: primaryContact ? +primaryContact.id : undefined,
          name: primaryContact ? primaryContact.name : ''
        }
      }
      this.infoInput = {
        name,
        typeIdx: quoteTypeKeys.findIndex(key => key === type),
        statusIdx: quoteStatusKeys.findIndex(key => key === status),
        priorTerm: {
          id: priorTerm ? +priorTerm.id : undefined,
          name: priorTerm ? priorTerm.policyName : ''
        },
        originalInceptionDate: originalInceptionDate ? originalInceptionDate + '' : ''
      }
      this.sourceInput = {
        source: {
          id: source ? +source.id : undefined,
          name: source ? source.name : ''
        }
      }
      const additionalInfo = JSON.parse(additionalInfoStr)
      this.additionalInfoInput = { ...additionalInfo }
    } else {
      this.clearForm()
    }

    if (this.accountInfo) {
      const { id, name, source } = this.accountInfo

      this.accountInput = {
        ...this.accountInput,
        account: {
          id: +id,
          name: name
        }
      }
      this.sourceInput = {
        ...this.sourceInput,
        source: {
          id: source ? source.id : undefined,
          name: source ? source.name : ''
        }
      }
    }

    if (this.carrierProductInfo) {
      this.carrierProductInput = {
        carrierProduct: {
          id: +this.carrierProductInfo.id,
          name: this.carrierProductInfo.name
        }
      }
    }

    if (this.caseInfo) {
      const {
        account: {
          id: accountId,
          name: accountName
        },
        source,
        recordType: {
          id: recordTypeId,
          name: recordTypeName
        },
        targetPolicy,
        type,
        asset
      } = this.caseInfo
      this.accountInput = {
        ...this.accountInput,
        account: {
          id: +accountId,
          name: accountName
        }
      }

      this.sourceInput = {
        ...this.sourceInput,
        source: {
          id: source ? +source.id : undefined,
          name: source ? source.name : ''
        }
      }

      this.recordTypeInput = {
        ...this.recordTypeInput,
        recordType: {
          id: +recordTypeId,
          name: recordTypeName
        }
      }

      this.infoInput = {
        ...this.infoInput,
        priorTerm: targetPolicy
          ? {
            id: +targetPolicy.id,
            name: targetPolicy.policyName
          } : {},
        typeIdx: quoteTypeKeys.findIndex(key => key === type),
        statusIdx: 0
      }

      if (targetPolicy && targetPolicy.carrierProduct) {
        this.carrierProductInput = {
          carrierProduct:
            {
              id: +targetPolicy.carrierProduct.id,
              name: targetPolicy.carrierProduct.name
            }
        }
      }

      if (asset) {
        this.additionalInfoInput = {
          address1: asset.property.address1 ? asset.property.address1 : '',
          address2: asset.property.address2 ? asset.property.address2 : '',
          city: asset.property.city ? asset.property.city : '',
          zipCode: asset.property.zipCode ? asset.property.zipCode : '',
          state: asset.property.state ? states.findIndex(st => asset.property.state === st) : -1
        }
      }
    }

    if (this.contactInfo) {
      this.accountInput = {
        ...this.accountInput,
        primaryContact: {
          id: +this.contactInfo.id,
          name: this.contactInfo.name
        }
      }
    }

    if (this.producerInfo) {
      this.sourceInput = {
        source: {
          id: +this.producerInfo.id,
          name: this.producerInfo.name
        }
      }
    }
  }

  handleStepClick (index: number) {
    if (!this.quote) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.quote) {
        this.handleUpdate()
      } else {
        this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    this.stepIndex -= 1
  }

  async handleCreate () {
    const {
      recordTypeInput: { recordType: { id: recordTypeId } },
      carrierProductInput: { carrierProduct: { id: carrierProductId } },
      accountInput: {
        account: {
          id: accountId
        },
        primaryContact: {
          id: primaryContactId
        }
      },
      infoInput: {
        name, typeIdx, statusIdx, originalInceptionDate,
        priorTerm: {
          id: priorTermId
        }
      },
      sourceInput: { source: { id: sourceId } },
      caseInfo
    } = this

    try {
      const res = await this.$apollo.mutate({
        mutation: newQuote,
        variables: {
          quoteInput: {
            name,
            originalInceptionDate,
            additionalInfoStr: this.parseAdditionalInfo(),
            recordTypeId,
            accountId,
            primaryContactId: primaryContactId || null,
            sourceId: sourceId || null,
            carrierProductId: carrierProductId,
            priorTermId: priorTermId || null,
            caseId: caseInfo ? Number(caseInfo.id) : null,
            type: quoteTypeKeys[typeIdx],
            status: quoteStatusKeys[statusIdx]
          }
        }
      })
      this.clearForm()
      this.onSuccess('Create the new quote successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    const {
      recordTypeInput: { recordType: { id: recordTypeId } },
      carrierProductInput: { carrierProduct: { id: carrierProductId } },
      accountInput: {
        account: {
          id: accountId
        },
        primaryContact: {
          id: primaryContactId
        }
      },
      infoInput: {
        name, typeIdx, statusIdx, originalInceptionDate,
        priorTerm: {
          id: priorTermId
        }
      },
      sourceInput: { source: { id: sourceId } }
    } = this

    try {
      const res = await this.$apollo.mutate({
        mutation: editQuote,
        variables: {
          quoteId: +this.quote.id,
          quoteInput: {
            name,
            originalInceptionDate: originalInceptionDate,
            additionalInfoStr: this.parseAdditionalInfo(),
            recordTypeId,
            accountId,
            primaryContactId: primaryContactId || null,
            sourceId: sourceId || null,
            carrierProductId: carrierProductId,
            priorTermId: priorTermId || null,
            type: quoteTypeKeys[typeIdx],
            status: quoteStatusKeys[statusIdx]
          }
        }
      })
      this.clearForm()
      this.onSuccess('Update quote successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  initSource (account: Account) {
    const { sourceInput } = this

    if (sourceInput.source && sourceInput.source.id) {
      return
    }
    if (account.source) {
      this.sourceInput.source = {
        id: +account.source.id,
        name: account.source.name
      }
    }
  }

  parseAdditionalInfo () {
    return JSON.stringify(this.additionalInfoInput, (key, value) => {
      return value === 0 ? '0' : (value || '')
    })
  }

  clearForm () {
    this.loading = false
    this.recordTypeInput = {
      recordType: {}
    }
    this.carrierProductInput = {
      carrierProduct: {}
    }
    this.accountInput = {
      account: {},
      primaryContact: {}
    }

    this.infoInput = {
      name: '',
      typeIdx: -1,
      statusIdx: -1,
      priorTerm: {},
      originalInceptionDate: ''
    }

    this.sourceInput = {
      source: {}
    }

    this.additionalInput = {}
  }

  @Emit('cancel')
  handleCancel () {
    this.$emit('input', false)
    this.clearForm()
  }

  @Emit('success')
  onSuccess (msg = '') {
    this.$emit('input', false)
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }
}
